module.exports = __webpack_public_path__ + "static/media/YM01_10.be5d079a.jpg";